import { Instagram } from "lucide-react";

const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

export const Footer = () => {
  return (
    <footer id="contacto" className="relative border-t border-white/10 bg-black py-20 px-6" data-testid="main-footer">
      <div className="max-w-4xl mx-auto text-center">
        <span className="text-gold text-lg">✦</span>
        <h2 className="font-serif-lux text-3xl tracking-[0.3em] uppercase text-white mt-6">Disfruta tu esencia</h2>
        <p className="text-neutral-500 font-light text-sm mt-4 max-w-md mx-auto">
          Esperamos que este perfume te acompañe y se convierta en parte de tus mejores recuerdos.
        </p>

        <div className="w-24 h-px bg-white/15 mx-auto my-10" />

        <p className="text-[11px] uppercase tracking-[0.3em] text-neutral-400 mb-6">¿Te encantó tu compra? Cuéntanoslo</p>
        <div className="flex items-center justify-center gap-8">
          <a
            data-testid="footer-instagram-link"
            href="https://instagram.com/maisonelixir.perfumes"
            target="_blank"
            rel="noopener noreferrer"
            className="text-neutral-400 hover:text-gold transition-colors duration-300"
            aria-label="Instagram"
          >
            <Instagram size={22} strokeWidth={1.5} />
          </a>
          <a
            data-testid="footer-tiktok-link"
            href="https://tiktok.com/@maison.elixir.per"
            target="_blank"
            rel="noopener noreferrer"
            className="text-neutral-400 hover:text-gold transition-colors duration-300"
            aria-label="TikTok"
          >
            <TikTokIcon size={20} />
          </a>
        </div>
        <p className="text-xs tracking-[0.3em] text-neutral-500 mt-5">@MAISONELIXIR.PERFUMES &nbsp;·&nbsp; @MAISON.ELIXIR.PER</p>

        <div className="w-24 h-px bg-white/15 mx-auto my-10" />

        <p className="font-script-lux text-gold text-4xl">Maison Élixir</p>
        <p className="text-[9px] uppercase tracking-[0.5em] text-neutral-600 mt-3">Parfums d'Exception — © {new Date().getFullYear()}</p>
      </div>
    </footer>
  );
};
